import React, { useEffect, useState } from 'react';
import ServiceCard from '../../Reusable/ServiceCard';
import { axiosInstance } from '../config';
import Icon3 from '../../../assets/images/we-do-icon-3.png';
import Loader from '../../common/Loader';

const Services = () => {
  const [services, setServices] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCustomersInfo();
  }, []);

  function getCustomersInfo() {
    setLoading(true);
    axiosInstance
      .get(`/services`)
      .then((res) => {
        setServices(res?.data?.service);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      {Loading && <Loader />}
      <div className="rs-services services-style1 bg2 py-5">
        <div className="container pt-md-5">
          <div className="row y-middle">
            {services?.map((obj, i) => {
              return <ServiceCard obj={obj} key={i} icon={Icon3} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
